<template>
  <div class="grid-container text-base">
    <section-header size="xl" variants="dividing">
      <heading qaid="warranty-details-heading" level="1" size="xl" v-html="`${bp('claimId')} ${claimId}`" />
    </section-header>

    <div v-for="(claim, index) in warrantyDetails" :key="index">
      <div v-if="Array.isArray(claim.consignments) && claim.consignments.length">
        <div v-for="consignment in claim.consignments" :key="consignment.packingSlip">
          <warranty-details-description
            :warranty-details="claim"
            :consignment="consignment"
            :base-properties="baseProperties"
          />
          <warranty-details-grid
            :base-properties="baseProperties"
            :warranty-details="claim"
            :consignment="consignment"
          />
        </div>
      </div>
      <warranty-details-grid v-else :base-properties="baseProperties" :warranty-details="claim" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SectionHeader from '@/components/SectionHeader';
import WarrantyDetailsDescription from '@/components/containers/warranty-claim/WarrantyDetails/WarrantyDetailsDescription';
import WarrantyDetailsGrid from '@/components/containers/warranty-claim/WarrantyDetails/WarrantyDetailsGrid';

export default {
  components: {SectionHeader, WarrantyDetailsDescription, WarrantyDetailsGrid},

  props: {
    claimId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      warrantyDetails: [],
    };
  },

  created() {
    this.getWarrantyDetails();
  },

  methods: {
    getWarrantyDetails() {
      axios
        .get(`/claims/json/v2/${this.claimId}`)
        .then((resp) => {
          if (resp?.data?.data) {
            this.warrantyDetails = resp.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
